import { CaseDetail } from "../../models/CaseDetail/caseDetail.model";
import {
  BUMP_CASE_CHAT_UNREAD,
  CLEAR_CASE_CHAT_UNREAD,
  MERGE_CASE_CHAT_UNREAD,
  SET_CASE_CHAT_DRAWER_CASE_ID,
  SET_CASE_DELETED,
  SET_CASE_DETAILS_UPDATED,
  SET_NEW_CASE_CREATED,
  SET_PENDING,
  SET_PENDING_CASE_IDS,
  SET_UPLOAD_COMPLETE,
  SET_UPLOAD_IN_PROGRESS,
  SET_UPLOAD_START,
} from "../definitions/caseConstants";

export interface SetPendingCaseIdsAction {
  type: typeof SET_PENDING_CASE_IDS;
  payload: { pendingCaseIds: number[] };
}

export interface SetPendingAction {
  type: typeof SET_PENDING;
  payload: { caseDetailId: number };
}

export interface SetNewCaseReceivedAction {
  type: typeof SET_NEW_CASE_CREATED;
  payload: { createdCaseId?: number | null };
}

export interface SetCaseDetailsUpdatedAction {
  type: typeof SET_CASE_DETAILS_UPDATED;
  payload: { updatedCaseId?: number | null };
}

export interface SetCaseDeletedAction {
  type: typeof SET_CASE_DELETED;
  payload: { deletedCaseId?: number | null };
}

export interface SetUploadStartAction {
  type: typeof SET_UPLOAD_START;
  payload: { caseDetailId: number };
}

export interface SetUploadInProgressAction {
  type: typeof SET_UPLOAD_IN_PROGRESS;
  payload: { caseDetailId: number };
}
export interface SetUploadCompleteAction {
  type: typeof SET_UPLOAD_COMPLETE;
  payload: { caseDetailId: number };
}

export const setPendingCaseIds = (
  pendingCaseIds: number[]
): SetPendingCaseIdsAction => ({
  type: SET_PENDING_CASE_IDS,
  payload: {
    pendingCaseIds: [...pendingCaseIds],
  },
});

export const setCaseDetailUpdated = (
  updatedCaseId?: number | null
): SetCaseDetailsUpdatedAction => ({
  type: SET_CASE_DETAILS_UPDATED,
  payload: {
    updatedCaseId,
  },
});

export const setNewCaseCreated = (
  createdCaseId?: number | null
): SetNewCaseReceivedAction => ({
  type: SET_NEW_CASE_CREATED,
  payload: {
    createdCaseId,
  },
});

export const setCaseDeleted = (
  deletedCaseId?: number | null
): SetCaseDeletedAction => ({
  type: SET_CASE_DELETED,
  payload: {
    deletedCaseId,
  },
});

export const setPending = (caseDetailId: number): SetPendingAction => ({
  type: SET_PENDING,
  payload: {
    caseDetailId,
  },
});

export const setUploadStart = (caseDetailId: number): SetUploadStartAction => ({
  type: SET_UPLOAD_START,
  payload: {
    caseDetailId,
  },
});

export const setUploadInProgress = (
  caseDetailId: number
): SetUploadInProgressAction => ({
  type: SET_UPLOAD_IN_PROGRESS,
  payload: {
    caseDetailId,
  },
});

export const setUploadComplete = (
  caseDetailId: number
): SetUploadCompleteAction => ({
  type: SET_UPLOAD_COMPLETE,
  payload: {
    caseDetailId,
  },
});

export interface MergeCaseChatUnreadAction {
  type: typeof MERGE_CASE_CHAT_UNREAD;
  payload: { counts: Record<number, number> };
}

export interface BumpCaseChatUnreadAction {
  type: typeof BUMP_CASE_CHAT_UNREAD;
  payload: { caseDetailId: number };
}

export interface ClearCaseChatUnreadAction {
  type: typeof CLEAR_CASE_CHAT_UNREAD;
  payload: { caseDetailId: number };
}

export const mergeCaseChatUnread = (
  counts: Record<number, number>
): MergeCaseChatUnreadAction => ({
  type: MERGE_CASE_CHAT_UNREAD,
  payload: { counts },
});

export const bumpCaseChatUnread = (
  caseDetailId: number
): BumpCaseChatUnreadAction => ({
  type: BUMP_CASE_CHAT_UNREAD,
  payload: { caseDetailId },
});

export const clearCaseChatUnread = (
  caseDetailId: number
): ClearCaseChatUnreadAction => ({
  type: CLEAR_CASE_CHAT_UNREAD,
  payload: { caseDetailId },
});

export interface SetCaseChatDrawerCaseIdAction {
  type: typeof SET_CASE_CHAT_DRAWER_CASE_ID;
  payload: { caseDetailId: number | null };
}

export const setCaseChatDrawerCaseId = (
  caseDetailId: number | null
): SetCaseChatDrawerCaseIdAction => ({
  type: SET_CASE_CHAT_DRAWER_CASE_ID,
  payload: { caseDetailId },
});
